import Button from '@mui/material/Button';
import { useIntl } from 'react-intl';
import { Link as RouterLink } from 'react-router-dom';
import { resolvePath, useQuery } from '../../routes';
import { subscription } from '../../layout/routes';

// Secondary (outlined) action per Billing 2.0 payment status design.
const ButtonToSubscriptionManagement = () => {
  const intl = useIntl();
  const { get } = useQuery();
  const accountId = get('accountId');

  return (
    <Button
      id="goto-sub-management-page"
      variant="outlined"
      size="large"
      sx={{
        height: 46,
        px: '22px',
        border: '1.5px solid #D7DBE0',
        borderRadius: '10px',
        backgroundColor: '#FFFFFF',
        color: '#16141D',
        fontSize: 14,
        fontWeight: 600,
        textTransform: 'none',
        whiteSpace: 'nowrap',
        '&:hover': {
          border: '1.5px solid #B9BFC6',
          backgroundColor: '#F7F8F9',
        },
      }}
      component={RouterLink}
      to={resolvePath(subscription, undefined, {
        accountId: Number(accountId),
      }, false)}
    >
      {intl.formatMessage({ id: 'payment_status.button.back_sub_management' })}
    </Button>
  );
};

export default ButtonToSubscriptionManagement;
